<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="배너 등록/수정" subtitle="배너를 신규 등록하여도 화면에 노출되지는 않습니다. 배너 영역을 신규로 추가하고자 하시는 경우 별도 문의가 필요합니다.">
            <div class="columns is-multiline">
              <div class="column is-5">
                <admin-form-item label="배너 제목*">
                  <input class="input"
                        :value="banner.title"
                        @input="e => banner.title = e.target.value"
                        placeholder="배너 제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배너 이미지/동영상" :desc="banner.pc ? ratiopc_desc : ratio_desc">
                  <lp-radio :val="banner.type"
                            style="margin:6px 0 12px 0"
                            value_name="value"
                            label_name="label"
                            @onSelect="selectType"
                            :data="[{label:'이미지',value:0},{label:'동영상 링크',value:2}]"></lp-radio>
                            <!--:data="[{label:'이미지',value:0},{label:'동영상 파일',value:1},{label:'동영상 링크',value:2}]"></lp-radio>-->
                  <!-- 이미지 -->
                  <div v-if="banner.type===0">
                    <!--
                    <draggable v-model="banner.imgs" handle=".item" @change="changeDraggable">
                      <div v-for="(img, idx) in banner.imgs" :key="'banner-'+idx" class="flex align-center">
                        <input-img style="display: inline-block;" :key="'img'+idx"
                                   class="item"
                                   :idx="(idx+1)*111154"
                                   @addImg="banner.imgs.push('')"
                                   :url.sync="banner.imgs[idx]"></input-img>
                        <input class="input"
                               :value="linkValue(idx)"
                               @input="e=>inputLink(e, idx)"
                               placeholder="배너를 누르면 이동할 경로를 입력해 주세요. ex) https://www.google.com"
                               type="text">
                      </div>
                    </draggable>
                    -->
                    <draggable v-model="banner.value_list" handle=".item">
                      <div v-for="(value, idx) in banner.value_list" :key="`banner-${idx}`" class="flex align-center">
                        <i style="color:#ccc" class="material-icons item unselect">drag_indicator</i>
                        <input-img style="display: inline-block;" :key="'img'+idx"
                                   :idx="(idx+1)*111154"
                                   :url.sync="value.img"></input-img>
                        <div class="full">
                          <div class="flex-end" style="margin-bottom:8px">
                            <button class="button is-danger" @click="removeValue(idx)">삭제</button>
                          </div>
                          <input class="input"
                                 v-model="value.link"
                                 @input="e=>value.link=e.target.value"
                                 placeholder="배너를 누르면 이동할 경로를 입력해 주세요. ex) https://www.google.com"
                                 type="text">
                        </div>
                      </div>
                    </draggable>
                    <div class="lp-add-img" style="margin-left:25px" @click="addImg">
                      <i class="material-icons">add</i>
                    </div>
                  </div>
                  <!-- 동영상 -->
                  <div v-if="banner.type===1" class="flex-align">
                    <input-file :value.sync="banner.imgs_ext"
                                acceptExt=".avi,.mp4,.mov"
                                style="width:50%"
                                description=""
                                :maxLength="1"
                                @setValue="val=>setVideo(val)"></input-file>
                    <!--<input class="input"
                           style="margin-left:24px"
                           :value="banner.links[0]"
                           @input="e=>banner.links[0]=e.target.value"
                           placeholder="배너를 누르면 이동할 경로를 입력해주세요."
                           type="text">-->
                  </div>
                  <!-- 동영상 링크 -->
                  <div v-if="banner.type===2">
                    <input class="input"
                           style="width:300px"
                           :value="banner.value_list[0].img"
                           @input="e=>setVideolink(e.target.value)"
                           placeholder="동영상 링크(youtube, vimeo)를 입력해주세요."
                           type="text">
                    <div class="description" style="font-size:11px;padding-left: 0">youtube링크는 해당 영상의 주소창에 표시되는 주소를 복사해서 입력하세요.</div>
                  </div>
                </admin-form-item>
              </div>
              <!--<div class="column is-full" v-if="banner.type===1 || banner.type===2">
                <admin-form-item label="동영상 설정">
                  <lp-check-group :list="playSettingList"
                                  :data="banner.play_setting"
                                  value_name="value"
                                  label_name="label"></lp-check-group>
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="PC용 배너" desc="체크 시 PC웹 배너를 설정하며, 체크 해제 시 모바일웹 배너를 설정합니다.">
                  <lp-check-bool :checked-val="banner.pc" @onCheck="banner.pc=!banner.pc"></lp-check-bool>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="!banner.pc">
                <admin-form-item :label="`${typeName} 비율(모바일)`"
                                 :desc="`최대 ${typeName} 크기는 가로,세로 1920이며, 이미지 비율에 맞게 업로드를 권장합니다.`+
                 '\nex) 4:3 비율은 1920:1440, 16:9 비율은 1920:1080, 2.35:1 비율은 1920: 817, 4:1 비율은 1920:480, 8:1 비율은 1920:240'">
                  <lp-radio :val.sync="banner.ratio"
                            value_name="value"
                            label_name="label"
                            :data="ratioArr"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="banner.pc">
                <admin-form-item :label="`${typeName} 비율(PC)`" :desc="`최대 ${typeName} 크기는 가로,세로 1920이며, 이미지 비율에 맞게 업로드를 권장합니다.`
                  +'\nex) 3:1 비율은 1920:640 , 4:1 비율은 1920:480 , 5:1 비율은 1920:384 , 8:1 비율은 1920:240'">
                  <lp-radio :val.sync="banner.ratio_pc"
                            value_name="value"
                            label_name="label"
                            :data="ratioPcArr"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배너 노출기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="banner.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                      :data="banner.end_date"
                      @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>


      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <!--<sweet-modal ref="productListModal">
      <product-list @productItems="productItems" page="exhibition" :selectedItems="id_list"  style="zoom: 0.85"></product-list>
    </sweet-modal>-->

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import moment from "moment";
import BreadCrumb from "../../module/common/BreadCrumb";
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import InputImg from "../../module/common/InputImg";
import LpAddress from "../../module/common/LpAddress";
import LpAdmDropInput from "../../module/common/LpAdmDropInput";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";
import ProductList from '../product/ProductList';
import { SweetModal } from 'sweet-modal-vue';
import CreateMixin from '@/mixins/CreateMixin';
import InputFile from "../../module/common/InputFile";
import LpCheckGroup from "../../module/common/LpCheckGroup";

export default {
  layout: "Main",
  components: {
    LpCheckGroup,
    InputFile,
    LpInputText,
    draggable,
    LpRadio,
    InputImg,
    LpAddress,
    LpAdmDropInput,
    SweetModal,
    ProductList,
    LpCheckBool,
    LpSortDropDown
  },
  mixins: [
    CreateMixin
  ],
  created() {
    /*this.nowTime=moment().format('YY-MM-DD');

    let start_year = parseInt(moment().format('YYYY'));
    let start_month = parseInt(moment().format('M'));
    let start_date = parseInt(moment().format('D'));

    let end_year = parseInt(moment().add(5, 'days').format('YYYY'));
    let end_month = parseInt(moment().add(5, 'days').format('M'));
    let end_date = parseInt(moment().add(5, 'days').format('D'));

    // this.banner.start_date = moment().format('YY-MM-DD');
    // this.banner.end_date = moment().add(5 ,'days').format('YY-MM-DD');
    this.banner.start_date = new Date (start_year, start_month-1, start_date);
    this.banner.end_date = new Date (end_year, end_month-1, end_date);
*/
    this.getData();
  },
  data() {
    return {
      playSettingList: [
        {label: '자동재생',value: 'auto_play'},
        {label: '연속재생',value: 'continuous_play'},
        {label: '음소거재생',value: 'mute_play'},
      ],
      nowTime: '',
      // 배너 정보
      banner: {
        value_list: [{img: '', link: ''}],
        imgs: [''],
        links: [''],
        play_setting: [],
        id: 0,
        // 배너 등록일
        reg_date: '',
        // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
        // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
        start_date:'',
        end_date:'',
        title: '',
        ratio: 0,
        pc: false,
        ratio_pc: 0,
        type: 0
      },
      olds: [
        {
          value_list: [{img: '', link: ''}],
          imgs: [''],
          imgs_ext: [''],
          links: [''],
        },
        {
          value_list: [],
          imgs: [],
          imgs_ext: [],
          links: [],
        },
        {
          value_list: [{img: '', link: ''}],
          imgs: [''],
          imgs_ext: [''],
          links: [''],
        }
      ],
      ratioArr: [
        { label: '1:1', value: 5 },
        { label: '1.3:1', value: 6 },
        { label: '4:3', value: 0 },
        { label: '16:9', value: 1 },
        { label: '2.35:1', value: 2 },
        { label: '4:1', value: 3 },
        { label: '8:1', value: 4 },
        { label: '풀스크린', value: 7}
      ],
      ratio_desc: '4:3 비율 1920:1440',
      ratioPcArr: [
        { label: '1:1', value: 4 },
        { label: '2:1', value: 5 },
        { label: '3:1', value: 0 },
        { label: '4:1', value: 1 },
        { label: '5:1', value: 2 },
        { label: '8:1', value: 3 },
        { label: '16:9', value: 7 },
        { label: '풀스크린', value: 6}
      ],
      ratiopc_desc: '3:1 비율 1920:640',
      // banner: {
      //   id: 82,
      //   // 배너 등록일
      //   reg_date: '17-12-30 10:24:20',
      //   // 노출여부 (현재 노출할것인지)
      //   display: true,
      //   // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
      //   // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
      //   displayAll: {
      //     state: true,   // true: 상시노출, false: 기간노출
      //     start: '18-01-02 12:00:00',
      //     end: '99-12-31 23:59:59'
      //   },
      //   type: '상품배너',
      //   img: 'http://pds.joins.com/news/component/newsis/201308/06/NISI20130806_0008507689_web.jpg',
      //   title: '여름맞이 창고 대개방',
      //   description: '여름맞이 창고 대개방 최대 70%까지 할인 행사',
      //   count: 20
      // },
    }
  },
  computed: {
    typeName() {
      return this.banner.type === 0 ? '이미지' : '동영상';
    }
  },
  watch: {
    'banner.ratio'(n) {
      switch (n) {
        case 0:
          this.ratio_desc = '4:3 비율 / 1920:1440';
          break;
        case 1:
          this.ratio_desc = '16:9 비율 / 1920:1080';
          break;
        case 2:
          this.ratio_desc = '2.35:1 비율 / 1920:817'
          break;
        case 3:
          this.ratio_desc = '4:1 비율 / 1920:480'
          break;
        case 4:
          this.ratio_desc = '8:1 비율 / 1920:240'
          break;
        default:
          this.ratio_desc = '';
          break;
      }
    },
    'banner.ratio_pc'(n) {
      switch (n) {
        case 0:
          this.ratiopc_desc = '3:1 비율 / 1920:640';
          break;
        case 1:
          this.ratiopc_desc = '4:1 비율 / 1920:480';
          break;
        case 2:
          this.ratiopc_desc = '5:1 비율 / 1920:384';
          break;
        case 3:
          this.ratiopc_desc = '8:1 비율 / 1920:240';
          break;
        case 5:
          this.ratiopc_desc = '2:1 비율 / 1920:960';
          break;
        default:
          this.ratiopc_desc = '';
          break;
      }
    }
    /*modalResponse(n){
      if(n==='close'){
        this.banner.products = n.productIdArr;
        this.productTable = n.productTable;
      }
    }*/
  },
  methods: {
    setVideo(val) {
      this.banner.imgs = [];
      this.banner.imgs.push(val[0]);
      this.banner.value_list = [];
      this.banner.value_list.push({img: val[0], link: ''});
    },
    setVideolink(val) {
      this.banner.imgs = [];
      this.banner.imgs.push(val);
      this.banner.value_list = [];
      this.banner.value_list.push({img: val, link: ''});
    },
    removeValue(idx) {
      removeIndex(this.banner.value_list, idx);
    },
    selectType(val) {
      let olds = this.olds[this.banner.type];
      olds.value_list = this.banner.value_list;
      olds.imgs = this.banner.imgs;
      olds.links = this.banner.links;
      olds.imgs_ext = this.banner.imgs_ext;

      this.banner.type = val;

      let cur = this.olds[val];
      this.banner.value_list = cur.value_list;
      this.banner.imgs_ext = cur.imgs_ext;
      this.banner.imgs = cur.imgs;
      this.banner.links = cur.links;
    },
    addImg() {
      // 최대 갯수 7개 제한
      /*if(this.banner.value_list.length >= 7) {
        this.toast('배너 이미지는 7개까지 추가할 수 있습니다.');
        return;
      }*/
      this.banner.value_list.push({img: '', link: ''});
    },
    linkValue(idx) {
      return this.banner.links[idx];
    },
    inputLink(e, idx) {
      this.banner.links[idx] = e.target.value;
    },
    imgField(img) {
      return 'background-image: url('+this.image(img)+');' +
        ' width: 60px; height: 60px; background-size: cover;' +
        ' background-position: center;';
    },
    // 배너 등록 상품 검색
    openSelectProduct(){
      /*let value = {
        productTable: this.productTable,
        productIdArr: this.banner.products
      }
      this.$store.commit('openModal', {type: 'modal-select-exhibition-product', value: value, width: '1080'})*/
      this.$modal.show('productListModal');
    },
    deleteProductItem(idx){
      removeIndex(this.productTable,idx);
      removeIndex(this.banner.products,idx);
      removeIndex(this.id_list,idx);
    },
    selDateMin(date) {
      this.banner.start_date = date;
      // this.getData();
    },
    selDateMax(date) {
      this.banner.end_date = date;
      // this.getData();
    },
    saveData() {
      let err = '';
      if(!this.banner.title) {
        err = '배너 제목을 입력해주세요.';
      }

      if(err) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.banner);
      value.imgs = [];
      value.links = [];
      value.value_list.forEach(item => {
        value.imgs.push(item.img);
        value.links.push(item.link);
      })
      if(!value.start_date){
        value.start_date = '1111-01-01';
      }
      if(!value.end_date){
        value.end_date = '9999-01-01';
      }
      if(this.$route.query.id){
        this.$store.commit('setLoading', true);
        this.$axios.patch(this.getUrl('banner/')+this.$route.query.id, value).then(res=>{
          if(res.status===200){
            this.$store.commit('setLoading', false);
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('banner'));
          }
        })
      }
      else{
        this.$store.commit('setLoading', true);
        this.$axios.post(this.getUrl('banner'), value).then(res=>{
          if(res.status===200){
            this.$store.commit('setLoading', false);
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('banner'));
          }
        })
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    getData(){
      if(this.$route.query.id){
        this.$axios.get(this.getUrl('banner/'+this.$route.query.id)).then(res=>{
          if(res.status===200){
            let banner = res.data;

            let value_list = [];
            for(let i=0; i<banner.imgs.length; i++) {
              value_list.push({link: banner.links[i], img: banner.imgs[i]})
            }
            banner.value_list = value_list;
            this.banner = banner;
            this.productTable = res.data.product_list;

            if (res.data.product_list) {
              for(let i=0; i<res.data.product_list.length; i++){
                this.id_list.push(res.data.product_list[i].id);
              }
            }
          }
        })
      }
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_variable';
//@import '~assets/css/lp_main';

.tr-whole-border th
  padding 12px 6px

.many-field-tr td
  padding 6px

.user-reg-basic-group-1 {
  width: 50%;
}

.user-reg-basic-group-2 {
  width: 50%;
  margin-top: 137px;
}

.user-reg-content-service {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.user-reg-service-group {
  width: 50%;
  padding-left: 20px;
  margin-bottom: 12px;
}

.user-reg-history-memo {
  width: 380px;
  height: 240px;
  margin: 0 10px;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  overflow-y: auto;
}

.history-memo-item {
  width: 100%;
  margin-bottom: 12px;
}

.user-reg-history-btn {
  background-color: $primary;
  color: #fff;
  display: inline-block;
  padding: 8px 12px;
  margin-left: 8px;
  border-radius: 3px;
  cursor: pointer;
}

.prod-search-btn {
  font-size: 0.8rem;
  background: #e6e6e6;
  padding: 6px 12px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}

.prod-tag
  background-color $point
  display inline-block
  padding 4px 10px
  color #fff
  border-radius 3px
  margin 2px

.prod-detail-content
  padding 20px
  font-size .95rem
  color #222
  border-radius 3px
  border none
  background-color #f2f7f8
  display block
  width 100%
  max-width 900px
  height 120px

.comment-sub-title
  background #ddd
  color #333
  padding 8px 16px
  font-size .95rem
  border-radius 3px
  display flex
  justify-content space-between
</style>
